import { QueryState } from "src/app/core/models/query.model";
import { createTokenQueryServiceInstance } from "src/app/core/services/query-sentrynel.service";
import { SignalStoreConfig } from "src/app/shared/functions/store.functions";

export const DANGEROUS_ELEMENT_ENDPOINT = 'catalog-dangerous-element';
export const DANGEROUS_ELEMENT_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(DANGEROUS_ELEMENT_ENDPOINT);

export const dangerousElementStateConfig: SignalStoreConfig<QueryState<any>> = {
  initState: {
    list: []
  }
}

export const LISTA_DANGEROUS_ELEMENT_COLUMNS: any[] = [
  {
    name: 'id',
    label: 'Id',
    field: 'id',
    primaryKey: true,
    type:'text'
  },
  {
    name: 'code',
    label: 'Codice',
    field: 'code',
    type:'text'
  },
  {
    name: 'name',
    label: 'Nome',
    field: 'name',
    type:'text'
  },
  {
    name: 'description',
    label: 'Descrizione',
    field: 'description',
    type:'text'
  },
  {
    name: 'elementType',
    label: 'Tipologia',
    field: 'elementType',
    type:'text',
    cell: ((el: any) => ELEMENT_TYPE.find(e => e.key === el.elementType)?.value)
  },
  {
    name: 'scopeType',
    label: 'Ambito',
    field: 'scopeType',
    type:'text'
  },
  {
    name: 'isActive',
    label: 'Attivo',
    field: 'isActive',
    type:'active'
  }
];

export const LISTA_DANGEROUS_ELEMENT_VISIBLE_COLUMNS = [
  'select',
  'code',
  'name',
  'description',
  'elementType',
  'isActive',
  'azioni',
];

export enum ELEMENT_TYPE_ENUM {
  BIOLOGICAL = 'BIOLOGICAL',
  CHEMICAL = 'CHEMICAL',
  PHYSICAL_ACCEPTABILITY = 'PHYSICAL-ACCEPTABILITY',
  PHYSICAL_QUANTITATIVE = 'PHYSICAL-QUANTITATIVE'
}

export const ELEMENT_TYPE =[
    {key: "BIOLOGICAL", value :"Biologico" },
    {key: "CHEMICAL", value :"Chimico"},
    {key: "PHYSICAL-ACCEPTABILITY", value :"Fisico-Accettabilità"},
    {key: "PHYSICAL-QUANTITATIVE", value :"Fisico-Quantitativo"}
  ]
